import React from 'react';
import { Link } from 'react-router-dom';
import { StarIcon } from '@heroicons/react/24/solid';
import { ClockIcon } from '@heroicons/react/24/outline';

const RelatedTours = ({ tours }) => {
  if (!tours || tours.length === 0) {
    return null;
  }

  return (
    <div className="bg-white rounded-lg shadow-md p-6 mb-8">
      <h3 className="text-xl font-bold mb-6">You Might Also Like</h3>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {tours.map((tour) => (
          <Link 
            key={tour.id} 
            to={`/tours/${tour.id}`}
            className="group block bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-shadow duration-300"
          >
            <div className="relative">
              <img 
                src={tour.image} 
                alt={tour.title} 
                className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-300"
              />
              <div className="absolute top-3 right-3 bg-white bg-opacity-90 px-2 py-1 rounded-md text-sm font-semibold">
                ${tour.price}
              </div>
            </div>
            
            <div className="p-4">
              <h4 className="font-semibold text-gray-800 mb-2 group-hover:text-primary transition-colors duration-300">
                {tour.title}
              </h4>
              
              <div className="flex items-center justify-between">
                <div className="flex items-center">
                  <StarIcon className="h-4 w-4 text-yellow-500" />
                  <span className="ml-1 text-sm font-medium">{tour.rating}</span>
                </div>
                
                <div className="flex items-center text-gray-500 text-sm">
                  <ClockIcon className="h-4 w-4 mr-1" />
                  <span>{tour.duration} {tour.duration === 1 ? 'day' : 'days'}</span>
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default RelatedTours;
